import { action } from 'typesafe-actions';

import { DevicesTypes, DevicesInterface } from './types';

// List Device
export const listDeviceRequest = (payload: object) =>
  action(DevicesTypes.LIST_DEVICE_REQUEST, payload);

export const listDeviceSuccess = (payload: { deviceData: DevicesInterface }) =>
  action(DevicesTypes.LIST_DEVICE_SUCCESS, payload);

export const listDeviceFailure = () => action(DevicesTypes.LIST_DEVICE_FAILURE);

// List Devices
export const listDevicesRequest = (payload: object) =>
  action(DevicesTypes.LIST_DEVICES_REQUEST, payload);

export const listDevicesSuccess = (payload: {
  devicesList: DevicesInterface[];
  totalCount: number;
}) => action(DevicesTypes.LIST_DEVICES_SUCCESS, payload);

export const listDevicesFailure = () =>
  action(DevicesTypes.LIST_DEVICES_FAILURE);

// Devices Update Status
export const updateStatusRequest = (payload: { id: string; status: number }) =>
  action(DevicesTypes.UPDATE_STATUS_REQUEST, payload);

export const updateStatusSuccess = () =>
  action(DevicesTypes.UPDATE_STATUS_SUCCESS);

export const updateStatusFailure = () =>
  action(DevicesTypes.UPDATE_STATUS_FAILURE);
